/**
 * Video Showcase: one active card (50% width), play on click, pause on leave section or when paused.
 * Desktop: play button only on hover when not playing. Mobile: play button always visible.
 */
(function () {
  var DESKTOP_BP = 750;

  function initSection(section) {
    if (section.dataset.videoShowcaseInited === 'true') return;
    section.dataset.videoShowcaseInited = 'true';

    var cardsRow = section.querySelector('[data-video-showcase-cards]');
    if (!cardsRow) return;

    var cards = section.querySelectorAll('[data-video-card]');
    var isDesktop = window.innerWidth >= DESKTOP_BP;

    function setActive(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-active');
      });
      if (card) card.classList.add('is-active');
    }

    function getActiveCard() {
      return section.querySelector('[data-video-card].is-active');
    }

    function pauseCard(card) {
      if (!card) return;
      var wrap = card.querySelector('[data-video-wrap]');
      var video = wrap && wrap.querySelector('video');
      if (video) {
        video.pause();
        video.muted = true;
      }
      card.classList.remove('is-playing');
      if (wrap) wrap.hidden = true;
      updatePlayBtnLabel(card);
    }

    function playCard(card) {
      if (!card) return;
      cards.forEach(function (c) {
        if (c !== card) pauseCard(c);
      });
      var wrap = card.querySelector('[data-video-wrap]');
      var video = wrap && wrap.querySelector('video');
      if (!video) return;
      wrap.hidden = false;
      video.muted = false;
      video.play().catch(function () {});
      card.classList.add('is-playing');
      updatePlayBtnLabel(card);
    }

    function updatePlayBtnLabel(card) {
      var playBtn = card.querySelector('[data-play-btn]');
      if (playBtn) {
        playBtn.setAttribute('aria-label', card.classList.contains('is-playing') ? 'Pause video' : 'Play video');
      }
    }

    function handleCardClick(card, e) {
      if (card.classList.contains('is-playing')) {
        pauseCard(card);
        setActive(null);
        updatePlayBtnLabel(card);
        e.preventDefault();
        return;
      }
      var playOverlay = card.querySelector('[data-play-overlay]');
      var playBtn = card.querySelector('[data-play-btn]');
      if (playOverlay && playOverlay.contains(e.target)) {
        e.preventDefault();
        setActive(card);
        playCard(card);
        updatePlayBtnLabel(card);
        return;
      }
      if (playBtn && playBtn.contains(e.target)) {
        e.preventDefault();
        setActive(card);
        playCard(card);
        updatePlayBtnLabel(card);
        return;
      }
      setActive(card);
    }

    function handleCardHover(card, entering) {
      if (!isDesktop) return;
      var active = getActiveCard();
      if (active && active !== card && active.classList.contains('is-playing')) return;
      if (entering && !active) {
        card.classList.add('is-active');
      } else if (entering && active === card) {
        return;
      } else if (!entering && active === card && !card.classList.contains('is-playing')) {
        setActive(null);
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        handleCardClick(card, e);
      });
      card.addEventListener('mouseenter', function () {
        handleCardHover(card, true);
      });
      card.addEventListener('mouseleave', function () {
        handleCardHover(card, false);
      });
    });

    var leaveObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var active = getActiveCard();
          if (active) {
            pauseCard(active);
            setActive(null);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );
    leaveObserver.observe(section);

    section.addEventListener('pause', function () {
      var active = getActiveCard();
      if (active) {
        pauseCard(active);
        setActive(null);
      }
    });

    var videos = section.querySelectorAll('[data-video-wrap] video');
    videos.forEach(function (video) {
      video.addEventListener('pause', function () {
        var card = video.closest('[data-video-card]');
        if (card) {
          card.classList.remove('is-playing');
          var wrap = video.closest('[data-video-wrap]');
          if (wrap) wrap.hidden = true;
          if (card.classList.contains('is-active')) setActive(null);
          updatePlayBtnLabel(card);
        }
      });
      video.addEventListener('ended', function () {
        var card = video.closest('[data-video-card]');
        if (card) {
          video.pause();
          card.classList.remove('is-playing');
          var wrap = video.closest('[data-video-wrap]');
          if (wrap) wrap.hidden = true;
          setActive(null);
          updatePlayBtnLabel(card);
        }
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('section[id^="video-showcase-"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('section[id^="video-showcase-"]') || e.target.closest('section[id^="video-showcase-"]');
    if (section) initSection(section);
  });
})();
